import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellStarter from './icon-nutshell-starter.svg';

function SvgComponent() {
    return <NutshellStarter height={40} width={70} />;
}

export const NutshellStarterIcon = svgIconWrapper(SvgComponent);
